(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-content"] && !Shopify.designMode) return;
  try {
    (function () {
    const selectors = {
      tocWrapper: '[article-toc="wrapper"]',
      toc: '[article-toc="toc"]',
      tocList: '[article-toc="list"]',
      tocItem: '[article-toc="item"]',
      tocLink: '[article-toc="link"]',
      content: '[article-toc="content"]',
      sourceTemplate: 'template[article-toc="source"]',
    };

    const root = document.querySelector(selectors.tocWrapper);
    if (!root) return;

    const templateEl = root.querySelector(selectors.sourceTemplate);
    const content = root.querySelector(selectors.content);
    const tocList = root.querySelector(selectors.tocList);

    if (!templateEl || !content || !tocList) return;

    const sourceContainer = document.createElement('div');
    sourceContainer.innerHTML = templateEl.innerHTML;

    const sourceHeadings = Array.from(
      sourceContainer.querySelectorAll('h2, h3')
    ).filter((heading) => heading.textContent.trim().length > 0);

    const visibleHeadings = Array.from(
      content.querySelectorAll('h2, h3')
    ).filter((heading) => heading.textContent.trim().length > 0);

    if (!sourceHeadings.length || !visibleHeadings.length) {
      root.querySelector(selectors.toc)?.setAttribute('hidden', 'hidden');
      return;
    }

    const count = Math.min(sourceHeadings.length, visibleHeadings.length);

    const slugify = (text) => {
      return text
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    };

    const extractLabel = (text) => {
      const shortMatch = text.match(/@@(.*?)@@/);
      const cleanedText = text.replace(/@@.*?@@/g, '').trim();
      const label = shortMatch ? shortMatch[1].trim() : cleanedText;
      return {
        label: label || cleanedText,
        cleanedText: cleanedText || text.trim(),
      };
    };

    const levelFor = (tagName) => parseInt(tagName.replace('H', ''), 10) || 2;
    const baseLevel = Math.min(
      ...visibleHeadings.slice(0, count).map((h) => levelFor(h.tagName))
    );

    for (let i = 0; i < count; i += 1) {
      const sourceHeading = sourceHeadings[i];
      const visibleHeading = visibleHeadings[i];

      const originalText = sourceHeading.textContent || '';
      const { label } = extractLabel(originalText);
      const visibleText = visibleHeading.textContent.trim();

      if (!visibleHeading.id) {
        const base = visibleText || label || `heading-${i + 1}`;
        visibleHeading.id = slugify(base) || `heading-${i + 1}`;
      }

      const item = document.createElement('li');
      const link = document.createElement('a');

      item.setAttribute('article-toc', 'item');
      link.setAttribute('article-toc', 'link');
      link.href = `#${visibleHeading.id}`;
      link.textContent = label;

      const level = levelFor(visibleHeading.tagName) - baseLevel;
      if (level > 0) {
        item.classList.add(`level-${level}`);
      }

      link.addEventListener('click', (event) => {
        event.preventDefault();
        const target = document.getElementById(visibleHeading.id);
        if (!target) return;

        if (document.startViewTransition) {
          document.startViewTransition(() => {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        } else {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        history.replaceState(null, '', `#${visibleHeading.id}`);
      });

      item.appendChild(link);
      tocList.appendChild(item);
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.id;
          if (!id) return;

          const link = tocList.querySelector(
            `a${selectors.tocLink}[href="#${id}"]`
          );
          if (!link) return;

          if (entry.isIntersecting) {
            tocList
              .querySelectorAll(`a${selectors.tocLink}[data-active="true"]`)
              .forEach((activeLink) => activeLink.removeAttribute('data-active'));

            link.setAttribute('data-active', 'true');
          }
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -60% 0px',
        threshold: 0.1,
      }
    );

    visibleHeadings.slice(0, count).forEach((heading) => observer.observe(heading));
  })();
  } catch(e) { console.error(e); }
})();

})();
